import * as React from "react"

type Props = {
  type?: "error" | "success"
}

const Feedback: React.FC<Props> = ({ children, type = "error" }) => {
  const style = React.useMemo(
    () =>
      ({
        border: `2px solid ${type === "error" ? "red" : "green"}`,
        padding: 8,
        fontWeight: "bold",
        marginTop: 8,
      } as const),
    [type]
  )
  return (
    <p role="alert" style={style}>
      {children}
    </p>
  )
}

export default Feedback
